import React, {ReactNode, useCallback, useState} from "react";
import {Dialog} from "@mui/material";
import {QrCodeScanner} from "../qr-code-scanner/qr-code-scanner";

interface DeliveryQrCodeActionProps {
    onSubmitSaleId: (saleId: number) => Promise<void> | void;
    onInvalidQrCode: () => void;
    renderTrigger: (openScanner: () => void, isReading: boolean) => ReactNode;
}

const extractSaleIdFromQrCode = (text: string) => {
    try {
        const data = JSON.parse(text);
        const parsedId = Number(data.os ?? data.id);
        if (Number.isFinite(parsedId)) {
            return parsedId;
        }
    } catch {
    }

    const parsedId = Number(text);
    if (Number.isFinite(parsedId)) {
        return parsedId;
    }

    return null;
};

export function DeliveryQrCodeAction({
    onSubmitSaleId,
    onInvalidQrCode,
    renderTrigger
}: DeliveryQrCodeActionProps) {
    const [open, setOpen] = useState(false);
    const [isReading, setIsReading] = useState(false);

    const openScanner = useCallback(() => {
        setIsReading(false);
        setOpen(true);
    }, []);

    const closeScanner = useCallback(() => {
        setOpen(false);
    }, []);

    const handleScanSuccess = useCallback(async (text: string) => {
        if (isReading) {
            return;
        }

        setIsReading(true);
        setOpen(false);

        const saleId = extractSaleIdFromQrCode(text);
        if (saleId === null) {
            onInvalidQrCode();
            setIsReading(false);
            return;
        }

        try {
            await onSubmitSaleId(saleId);
        } finally {
            setIsReading(false);
        }
    }, [isReading, onInvalidQrCode, onSubmitSaleId]);

    return (
        <React.Fragment>
            {renderTrigger(openScanner, isReading)}
            <Dialog open={open} onClose={closeScanner} fullWidth maxWidth={"xl"}>
                <QrCodeScanner onScanSuccess={handleScanSuccess}/>
            </Dialog>
        </React.Fragment>
    );
}
